__turbopack_context__.v({
  "icon": "VideoTabs-module-scss-module__iXGiaq__icon",
});
